/**
 * Estado civil
 * Possiveis sutuações para o registro Brasileiro
 */

const SOLTEIRO = { name: 'Solteiro', value: 'SOLTEIRO', genero: 'M' }
const CASADO = { name: 'Casado', value: 'CASADO', genero: 'M' }
const VIUVO = { name: 'Viúvo', value: 'VIUVO', genero: 'M' }
const SEPARADO_JURIDICAMENTE = { name: 'Separado Judicialmente', value: 'SEPARADO', genero: 'M' }
const DIVORCIADO = { name: 'Divorciado', value: 'DIVORCIADO', genero: 'M' }

const SOLTEIRA = { name: 'Solteira', value: 'SOLTEIRO', genero: 'F' }
const CASADA = { name: 'Casada', value: 'CASADO', genero: 'F' }
const VIUVA = { name: 'Viúva', value: 'VIUVO', genero: 'F' }
const SEPARADA_JURIDICAMENTE = { name: 'Separada Judicialmente', value: 'SEPARADO', genero: 'F' }
const DIVORCIADA = { name: 'Divorciada', value: 'DIVORCIADO', genero: 'F' }

const IGNORADO = { name: 'Ignorado', value: 'IGNORADO', genero: 'M' }
const IGNORADA = { name: 'Ignorada', value: 'IGNORADO', genero: 'F' }

const OUTROS = { name: 'Outros', value: 'OUTROS', genero: 'M' }
const OUTRAS = { name: 'Outras', value: 'OUTROS', genero: 'F' }

const ESTADOS_CIVIL = [ SOLTEIRO,SOLTEIRA, CASADO,CASADA, VIUVO,VIUVA, SEPARADO_JURIDICAMENTE,SEPARADA_JURIDICAMENTE, DIVORCIADO,DIVORCIADA, IGNORADO, IGNORADA, OUTROS, OUTRAS ]
const ESTADOS_CIVIL_HABILITACAO = [ SOLTEIRO,SOLTEIRA, VIUVO,VIUVA, DIVORCIADO,DIVORCIADA, IGNORADO, IGNORADA, OUTROS, OUTRAS ]

//constante para facilitar o tratamento do valor que vem do banco
const ESTADO_CIVIL_OBJ = {
  SEPARADO_JUDICIALMENTE: "Separado",
  SOLTEIRO: "Solteiro",
  CASADO: "Casado",
  VIUVO: "Viúvo",
  DIVORCIADO: "Divorciado",
  SEPARADA_JUDICIALMENTE: "Separado",
  SOLTEIRA: "Solteiro",
  CASADA: "Casado",
  VIUVA: "Viúvo",
  DIVORCIADA: "Divorciado",
  IGNORADO: "Ignorado",
  IGNORADA: "Ignorado",
  OUTROS: "Outros",
  OUTRAS: "Outros"
}

export {ESTADOS_CIVIL, ESTADO_CIVIL_OBJ, ESTADOS_CIVIL_HABILITACAO}
